<template>
    <label class="
        r:8 height:48 font-md cursor:pointer b:1|solid|gray300 d:grid place-items:center cursor:pointer white-space:nowrap overflow:hidden
        {d:none}_input[type=checkbox]
        {b:1|solid|y200;bg:y200}:has(input:checked)
    ">
        <p>{{ label }}</p>
        <input @change="change" :checked="checked" type="checkbox" :value="value" v-bind="$attrs" />
    </label>
</template>

<script setup>
    const props = defineProps({
        label: { required: true, type: String },
        modelValue: { type: [Array, Number, String] },
        value: { required: true, type: [Number, String] }
    });

    const checked = computed(() => {
        if (props.modelValue instanceof Array) {
            return props.modelValue.includes(props.value);
        } else {
            return props.modelValue === props.value;
        }
    });

    const change = (event) => {
        let values;
        const checked = event.target.checked;

        if (props.modelValue instanceof Array) {
            values = [...props.modelValue];

            if (checked) {
                values.push(props.value);
            } else {
                values.splice(values.indexOf(props.value), 1);
            }
        } else {
            values = checked;
        }

        emit("update:modelValue", values);
    };

    const emit = defineEmits(["update:modelValue"]);

    defineOptions({ inheritAttrs: false });
</script>
